// @flow
import PrivateRoute from 'components/PrivateRoute'
import FormBuilder from 'pages/FormBuilder'
import FormBuilderSettingsCustomInvite from 'pages/FormBuilderSettingsCustomInvite'
import FormBuilderSettingsGeneral from 'pages/FormBuilderSettingsGeneral'
import FormBuilderSettingsNotifications from 'pages/FormBuilderSettingsNotifications'
import * as React from 'react'
import { Switch } from 'react-router-dom'

import { FormAppearance } from '../FormAppearance'
import { CustomCompletePage } from '../FormBuilderSettingsCompletePage/CustomCompletePage'
import FormBuilderWrapper from './Components/FormBuilderWrapper'

function FormBuilderRouter(): React.Node {
  return (
    <FormBuilderWrapper>
      <Switch>
        <PrivateRoute
          exact
          component={FormBuilder}
          path={'/builder'} // deprecated
        />
        <PrivateRoute
          exact
          component={FormBuilder}
          path={'/builder/edit/:resourceId'} // deprecated
        />
        <PrivateRoute
          exact
          component={FormBuilderSettingsGeneral}
          path={'/forms/:resourceId/settings/general'}
        />
        <PrivateRoute
          exact
          component={FormAppearance}
          path={'/forms/:resourceId/design'}
        />
        <PrivateRoute
          exact
          component={FormBuilderSettingsNotifications}
          path={'/forms/:resourceId/settings/notifications'}
        />
        <PrivateRoute
          exact
          component={FormBuilderSettingsCustomInvite}
          path={'/forms/:resourceId/settings/custom-email-and-sms-invitation'}
        />
        <PrivateRoute
          exact
          component={CustomCompletePage}
          path={'/forms/:resourceId/settings/complete-page'}
        />
      </Switch>
      <PrivateRoute exact component={FormBuilder} path={'/forms/:resourceId'} />
    </FormBuilderWrapper>
  )
}

export default FormBuilderRouter
